export default __webpack_public_path__ + "static/media/weth-logo.a7e220f8.svg";